





























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import IRolePermission from '@/store/models/IRolePermission';
import IOutboundDocument from '@/store/models/IOutboundDocument';
import IListCustomPaper from '@/store/models/IListCustomPaper';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import vue2Dropzone from 'vue2-dropzone';
import { v4 as uuidv4 } from 'uuid';
@Component({
    components: {
        vueDropzone: vue2Dropzone
    }
})
export default class OutboundDocument extends Vue {
    @Prop({ type: Array, required: true })
    Permissions !: IRolePermission[];
    @Prop({ type: Array, required: true })
    OutboundDocuments !: IOutboundDocument[];
    @Prop({ type: Array, required: true })
    OutboundDocumentsCompanyDestination !: IOutboundDocument[];
    @Prop({ type: Array, required: true })
    OutboundDocumentsCompanySource !: IOutboundDocument[];
    @Prop({ type: Array, required: true })
    CustomPaperList !: IListCustomPaper[];
    @Prop()
    CompanySourceName !: String;
    @Prop({ type: String, required: true })
    OutboundCode !: String;
    @Prop()
    CompanyDestinationName !: String;

    selectedCustomPaper: IListCustomPaper[] = [];
    currFiles: any[] = [];
    files: any[] = [];
    selectedDocumentSourceCompany: any[] = [];
    selectedDocumentDestinationCompany: any[] = [];
    dropzoneOptions: any = {
        url: 'http://localhost',
        thumbnailWidth: 150,
        maxFilesize: 25,
        headers: { "My-Awesome-Header": "header value" },
        addRemoveLinks: true,
        maxFiles: 10,
        previewsContainer: false
    }
	
    appendLocation(file: any) {
        this.files.push(file);
    }
	
    onMaxFilesReached(files: any[]) {
        this.$emit("showMessageWarning", "A maximum of 10 files may be uploaded.");
        if (files.length > 10) {
            files.slice(10).forEach((file) => {
                this.remove(file);
            });
        }
    }

    download(item: IOutboundDocument) {
        this.$emit("downloadOutboundDocument", item);
    }

    deleteOutboundDocument(item: IOutboundDocument) {
        this.$emit("deleteOutboundDocument", item);
    }

    remove(index: number) {
        this.files.splice(index, 1);
        // this.currFiles.splice(index, 1);
    }

    uploadFiles() {
        if (!this.files) {
            this.$emit("showMessageWarning", "Please select a file");
        }
        
        let formDatas : FormData = this.getFormData();
        let fileNames : string[] = [];
        for (let i in this.files) {
            fileNames.push(this.sanitizeFileName(this.files[i].name));
        }
        if (fileNames.length !== this.selectedCustomPaper.length) {
            this.$emit("showMessageWarning", "Please select a document type for all documents");
        } else {
            this.$emit('uploadOutboundDocument', formDatas, fileNames, this.selectedCustomPaper);
            this.currFiles = [];
            const dropzoneComponent = this.$refs.myVueDropzone as any;
            if (dropzoneComponent && typeof dropzoneComponent.removeAllFiles === 'function') {
                dropzoneComponent.removeAllFiles();
            }
            this.files = [];
        }
    }

    sanitizeFileName(fileName: string): string {
        return fileName
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9._-]/g, "_")
        .replace(/_{2,}/g, "_")
        .replace(/^_+|_+$/g, "");
    }

    getFormData () : FormData {
        let formData = new FormData();
        for (let file of this.files) {
            let name = uuidv4();
            formData.append("files", file, name);
        }
        return formData;
    }
}
